export const planningPolygonRefuelCount = (polygon, selectedOut, useLoadOptimization) => {
    const count = useLoadOptimization && selectedOut && selectedOut.qtdFuel != null
        ? selectedOut.qtdFuel
        : polygon && polygon.flxMedApl;
    const value = Number(count);
    return Number.isFinite(value) && value >= 0 ? value : 0;
};
